import React from "react";
import FooterLogo from "../assets/footer-logo.svg";
import { MdOutlineArrowUpward } from "react-icons/md";

const Footer = () => {
  return (
    <div className="footer__wrapper">
      <a href="#" className="footer__logo">
        <img src={FooterLogo} alt="" />
        <span className="footer__scroll-top">
          Top <MdOutlineArrowUpward />
        </span>
      </a>
      <div className="footer__link--wrapper">
        <div>
          <a target="_blank" href="https://github.com/Moe-Zart/">Github</a>
        </div>
        <div>
          <a target="_blank" href="https://www.linkedin.com/in/mohamed-zreika-27b2b6242/">LinkedIn</a>
        </div>
        <div>
          <a target="_blank" href="mailto:mohamedzreika03@outlook.com">Email</a>
        </div>
        <div>
          <a target="_blank" href="/resume.pdf">Resume</a>
        </div>
      </div>
      <div>Copyright &copy; 2023 Mohamed Zreika</div>
    </div>
  );
};

export default Footer;
